// routes

import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgIconStyle from "../../../components/SvgIconStyle";
import { PATH_LEVEL } from "utils/dataCenter";
import { Headquarter } from "redux/slices/auth";

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: "100%", height: "100%" }}
  />
);

const ICONS = {
  cart: getIcon("ic_cart"),
  setting: getIcon("ic_setting"),
  home: getIcon("ic_home"),
  trendingup: getIcon("ic_trendingup"),
  description: getIcon("ic_descript"),
  appinfo: getIcon("ic_appInfo"),
  receipt: getIcon("ic_receipt"),
  store: getIcon("ic_store"),
};

export const getSidebarConfig = (headquarter: Headquarter) => {
  const sidebarConfig: any = [
    {
      subheader: "종합 정보",
      items: [
        {
          title: "종합 정보",
          path: PATH_DASHBOARD.hq_home.root,
          icon: ICONS.appinfo,
          children: [
            {
              title: "매출 분석",
              path: PATH_DASHBOARD.hq_home.hq_salesanalytics,
            },
          ],
        },
      ],
    },
    {
      subheader: "브랜드별 관리",
      items: [
        {
          title: "브랜드별 관리",
          path: PATH_DASHBOARD.hq_brand.root,
          icon: ICONS.home,
          children: [],
        },
      ],
    },
    {
      subheader: "매장별 관리",
      items: [
        {
          title: "매장별 관리",
          path: PATH_DASHBOARD.hq_store.root,
          icon: ICONS.store,
          children: [],
        },
      ],
    },
    {
      subheader: "종합보고서",
      items: [
        {
          title: "종합보고서",
          path: PATH_DASHBOARD.hq_report.root,
          icon: ICONS.receipt,
        },
      ],
    },
  ];
  const { HEADQUARTER_AUTH, companyObjs } = headquarter;
  let PLUG_IN_MA = false;
  for (const company of companyObjs) {
    if (company.PLUG_IN_MA) {
      PLUG_IN_MA = true;
      break;
    }
  }
  switch (HEADQUARTER_AUTH?.toString()) {
    case PATH_LEVEL.BASIC:
    case PATH_LEVEL.STANDARD:
    case PATH_LEVEL.PREMIUM:
      sidebarConfig[1].items[0].children = [
        {
          title: "매출 분석",
          path: PATH_DASHBOARD.hq_brand.hq_salesanalytics,
        },
        {
          title: "발주 분석",
          path: PATH_DASHBOARD.hq_brand.hq_orderanalytics,
        },
        {
          title: "판매 분석",
          path: PATH_DASHBOARD.hq_brand.hq_sellsanalytics,
        },
        {
          title: "메뉴별 판매량",
          path: PATH_DASHBOARD.hq_brand.hq_sellsdetailanalytics,
        },
      ];
      sidebarConfig[2].items[0].children = [
        {
          title: "매출 분석",
          path: PATH_DASHBOARD.hq_store.hq_salesanalytics,
        },
        {
          title: "발주 분석",
          path: PATH_DASHBOARD.hq_store.hq_orderanalytics,
        },
        {
          title: "판매 분석",
          path: PATH_DASHBOARD.hq_store.hq_sellsanalytics,
        },
        {
          title: "메뉴별 판매량",
          path: PATH_DASHBOARD.hq_store.hq_sellsdetailanalytics,
        },
      ];

      break;
    default:
      sidebarConfig[1].items[0].children = [
        {
          title: "매출 분석",
          path: PATH_DASHBOARD.hq_brand.hq_salesanalytics,
        },
        {
          title: "판매 분석",
          path: PATH_DASHBOARD.hq_brand.hq_sellsanalytics,
        },
        {
          title: "메뉴별 판매량",
          path: PATH_DASHBOARD.hq_brand.hq_sellsdetailanalytics,
        },
      ];
      sidebarConfig[2].items[0].children = [
        {
          title: "매출 분석",
          path: PATH_DASHBOARD.hq_store.hq_salesanalytics,
        },
        {
          title: "판매 분석",
          path: PATH_DASHBOARD.hq_store.hq_sellsanalytics,
        },
        {
          title: "메뉴별 판매량",
          path: PATH_DASHBOARD.hq_store.hq_sellsdetailanalytics,
        },
      ];
      break;
  }
  if (PLUG_IN_MA) {
    sidebarConfig[1].items[0].children.push({
      title: "지역 분석",
      path: PATH_DASHBOARD.hq_brand.hq_mapanalytics,
    });
  }
  return sidebarConfig;
};
